import axios from "axios";
import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { API_URL } from "../../config";

const Privateroute = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const token = params.get("accessToken");

  const [loading, setLoading] = useState(true);

  const fetchUserByUserId = async () => {
    try {
      const res = await axios.get(`${API_URL}/distributor/me`, {
        headers: {
          "x-access-token": token,
        },
      });

      const data = res.data;

      localStorage.setItem("user_id", data.user_id);
      localStorage.setItem("accessToken", data.accessToken);
      localStorage.setItem("user_type", data.data[0].user_type);
      localStorage.setItem("uid", data.data[0].uid);
      localStorage.setItem(
        "user_name",
        `${data.data[0].firstname} ${data.data[0].lastname}`
      );
      if (data.data[0].site_id) {
        localStorage.setItem("site_id", data.data[0].site_id);
      }

      if (data.data[0].user_type) {
        navigate(location.pathname, { replace: true });
      }

    } catch (err) {
      console.error(
        "Error fetching distributor:",
        err.response?.data || err.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchUserByUserId();
    } else {
      setLoading(false);
    }
  }, [token]);

  if (loading) return null; // or a spinner

  const auth = localStorage.getItem("user_id");
  return auth ? <Outlet /> : <Navigate to="/login" />;
};

export default Privateroute;
